import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WithFirebaseAnonUser from "./WithFirebaseAnonUser";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {SECONDARYCOLOR} from "./ThemeSettings";
import {WifiOff} from "@mui/icons-material";
import {Flex} from "reflexbox";

const FirebaseWrapper = (props) => {
  // Get the required data from the Redux store using useSelector
  //this is needed to avoid calling store.getState() while the reducer is executing.
  const { uid } = useSelector((state) => state.user);
  const { currentTeamId, teamDetails } = useSelector((state) => state.team);
  const platform = useSelector((state) => state.platform);
  const { connection } = platform;

  const [showConnectionError, setShowConnectionError] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (!connection) {
      // Only show the connection error dialog if we've been offline
      // continuously for a short period, to avoid brief flickers.
      timeoutId = setTimeout(() => {
        setShowConnectionError(true);
      }, 2500); // 2.5 seconds
    } else {
      // As soon as we are reconnected, hide the dialog and clear any pending timeout.
      setShowConnectionError(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [connection]);

  return (
    <WithFirebaseAnonUser currentTeamId={currentTeamId} teamDetails={teamDetails} uidInRedux={uid} connection={connection}>
      <Dialog
        open={showConnectionError}
      >
        <Flex style={{justifyItems: 'center', justifyContent: 'center', alignItems: 'center', width:'100%', paddingTop: '16px'}}>
          <WifiOff style={{ color: SECONDARYCOLOR }}  fontSize="large"/>
        </Flex>
        <DialogTitle style={{color: SECONDARYCOLOR}}>Connection Error</DialogTitle>

        <DialogContent>
          <DialogContentText >
            Can't reach game servers, check your connection. Attempting to reconnect...
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {props.children}
    </WithFirebaseAnonUser>
  );
};

export default FirebaseWrapper;
